// Image Modal Styles
// Full-screen image viewer with black background

import styled from "styled-components";
import { theme } from "../theme";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.md};
  cursor: pointer;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: default;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: ${theme.borderRadius.md};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
`;

export const CloseButton = styled.button`
  position: fixed;
  top: ${theme.spacing.md};
  right: ${theme.spacing.md};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${theme.colors.text.primary};
  font-size: 2rem;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10001;
  line-height: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
    top: ${theme.spacing.sm};
    right: ${theme.spacing.sm};
  }
`;

export const ImageInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: ${theme.spacing.lg};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  border-radius: 0 0 ${theme.borderRadius.md} ${theme.borderRadius.md};

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
  }
`;

export const ImageUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  flex: 1;
  min-width: 0;
`;

interface ProfileIconProps {
  $avatarUrl: string;
}

export const ProfileIcon = styled.button<ProfileIconProps>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid ${theme.colors.background.primary};
  background-image: url(${(props) => props.$avatarUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  }

  &:active {
    transform: scale(0.95);
  }

  /* Fallback if avatar image fails to load */
  &::after {
    content: "👤";
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: ${theme.colors.background.secondary};
    border-radius: 50%;
    font-size: 1.25rem;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 40px;
    height: 40px;
  }
`;

export const ImageDescription = styled.p`
  margin: ${theme.spacing.xs} 0 0 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;
  line-height: 1.4;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.8rem;
  }
`;

export const ImageLikes = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  color: ${theme.colors.text.primary};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.full};
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  flex-shrink: 0;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.8rem;
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
  }
`;

export const UsernameText = styled.div`
  font-weight: 600;
  color: #fff;
  font-size: 1rem;
  margin-bottom: ${theme.spacing.xs};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

